export function insertItem(array: Array<any>, item: any) {
  return [...array, item]
}

export function removeItemByIndex<T>(array: Array<T>, index: number) {
  const newArray = array.slice()
  newArray.splice(index, 1)
  return newArray
}

export function replaceElement<T>(array: T[], index: number, object: T): T[] {
  return Object.assign([], array, { [index]: object })
}

export function removeItem(
  array: Array<any>,
  itemToDelete: any,
  equalityCallback?: (item1: any, item2: any) => boolean
) {
  return removeItemByIndex(array, getIndexOfItem(array, itemToDelete, equalityCallback))
}

export function findIndex(array: Array<any>, callback: (item: any) => boolean) {
  for (let i = 0, l = array.length; i < l; i++) {
    if (callback(array[i])) {
      return i
    }
  }
  return null
}

export function getIndexOfItem(
  array: Array<any>,
  itemToSearch: any,
  equalityCallback?: (item1: any, item2: any) => boolean
) {
  for (let i = 0, l = array.length; i < l; i++) {
    const item = array[i]
    if ((!!equalityCallback && equalityCallback(item, itemToSearch)) || item === itemToSearch) {
      return i
    }
  }
  return -1
}

export function updateObjectInArray<T>(array: Array<T>, updateIndex: number, updatedItem: T) {
  return array.map((item, index) => {
    if (index !== updateIndex) {
      return item
    }

    return {
      ...item,
      ...updatedItem,
    }
  })
}

export function replaceObjectInArray<T>(array: Array<T>, updateIndex: number, updatedItem: T) {
  if (updateIndex === -1) {
    return [...array, updatedItem]
  }
  return array.map((item, index) => {
    if (index !== updateIndex) {
      return item
    }

    return updatedItem
  })
}

export function arrayToObjectKeys(array: Array<any>, initialValue?: any) {
  const obj = {}
  for (let i = 0, l = array.length; i < l; i++) {
    obj[array[i]] = initialValue !== undefined || initialValue !== null ? initialValue : ''
  }
  return obj
}
